/*
 * Custom Product Accordion — exclusive single-open behavior.
 *
 * Modern browsers already enforce this via <details name="...">. This is the
 * fallback for browsers that don't support the name attribute: when one card
 * opens, close every other card in the same group. Idempotent — safe to load
 * once even though the snippet references it per block.
 */
(function () {
  if (window.__customAccordionInit) return;
  window.__customAccordionInit = true;

  // `toggle` does not bubble, so listen in the capture phase.
  document.addEventListener(
    'toggle',
    function (e) {
      var details = e.target;
      if (!details.matches || !details.matches('details[data-acc-group]')) return;
      if (!details.open) return;

      var group = details.getAttribute('data-acc-group');
      var siblings = document.querySelectorAll('details[data-acc-group="' + group + '"]');
      Array.prototype.forEach.call(siblings, function (other) {
        if (other !== details && other.open) other.open = false;
      });
    },
    true
  );
})();
